import React, { useState, useEffect, useRef } from 'react';

const LazyLoader = ({ src, alt, placeholder, className, ...props }) => {
  const [isInView, setIsInView] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px' } 
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleImageLoad = () => {
    setIsLoaded(true);  
  };

  return (
    <div
      className={`lazy-load-wrapper relative ${className}`}
      style={{ position: 'relative', height: 'auto', overflow: 'hidden' }}
      {...props}
    >
      <div
        className={`placeholder-box ${isInView ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300 ease-in-out`} // Faster transition for placeholder
        style={{
          paddingTop: '56.25%',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: placeholder || '#f0f0f0',
        }}
      ></div>

      <img
        ref={imgRef}
        src={isInView ? src : ''}
        alt={alt}
        className={`w-full h-full object-cover transition-all duration-500 ${isLoaded ? 'opacity-100' : 'opacity-0'}`} 
        style={{
          clipPath: isLoaded ? 'inset(0 0 0 0)' : 'inset(0 0 100% 0)',  
          opacity: isLoaded ? 1 : 0,
          transition: 'clip-path 0.5s ease-out, opacity 0.5s ease-out',  
        }}
        onLoad={handleImageLoad}
      />
    </div>
  );
};

export default LazyLoader;
